<div class="row mb-4">
  <div class="col-12">
    <button *ngIf="!mappaturaOpen" class="navigation-button" mat-flat-button routerLinkActive="navigation-button-active"
      routerLink="/{{ lang }}/app/properties/{{propertyId}}/documents">
      {{ 'properties.list.goToDocuments' | translate }}
    </button>

    <button *ngIf="mappaturaOpen" class="navigation-button" mat-flat-button (click)="onGoToDocumentArchive()">
      {{ 'properties.list.goToDocuments' | translate }}
    </button>

    <button class="navigation-button" mat-flat-button routerLinkActive="navigation-button-active"
      routerLink="/{{ lang }}/app/properties/{{propertyId}}/mapping">
      {{ 'properties.list.goToMapping' | translate }}
    </button>

    <button class="navigation-button" mat-flat-button routerLinkActive="navigation-button-active"
      *ngIf="loggedUserPermissions.includes('canSearchDocuments')"
      routerLink="/{{ lang }}/app/properties/{{propertyId}}/search">
      {{ 'properties.list.searchDocuments' | translate }}
    </button>

    <button class="navigation-button" mat-flat-button routerLinkActive="navigation-button-active"
      routerLink="/{{ lang}}/app/properties/{{propertyId}}/addDocuments"
      *ngIf="loggedUserPermissions.includes('canCreateDigitalDocuments') && loggedUserMaster"
    >
      {{ 'properties.documentsPage.insertDocs' | translate }}
    </button>

    <button class="navigation-button" mat-flat-button routerLinkActive="navigation-button-active"
      routerLink="/{{ lang}}/app/properties/{{propertyId}}/addNewDocuments"
      *ngIf="loggedUserPermissions.includes('canCreateDigitalDocuments') && loggedUserAdmin"
    >
      {{ 'properties.documentsPage.insertDocs' | translate }}
    </button>

    <button class="navigation-button float-right" color="primary" (click)="onViewMapping()" mat-flat-button
      matTooltip="{{ 'properties.detail.mappingTab.viewMapping' | translate }}" matTooltipPosition="above" *ngIf="loggedUserAdmin">
      <mat-icon fontSet="fal" fontIcon="fa-qrcode"></mat-icon> {{ 'properties.detail.mappingTab.viewMapping' | translate }}
    </button>
    <button class="navigation-button float-right" color="primary" (click)="onPrintQRcode()" mat-flat-button
      matTooltip="{{ 'properties.detail.mappingTab.printQrcode' | translate }}" matTooltipPosition="above" *ngIf="loggedUserAdmin">
      <mat-icon fontSet="fal" fontIcon="fa-qrcode"></mat-icon> {{ 'properties.detail.mappingTab.printQrcode' | translate }}
    </button>
    <button class="navigation-button float-right" color="accent" (click)="onSendQrcodeByEmail()" mat-flat-button
      matTooltip="{{ 'properties.detail.mappingTab.sendQrcodeByEmail' | translate }}" matTooltipPosition="above" *ngIf="loggedUserAdmin">
      <mat-icon fontSet="fal" fontIcon="fa-paperclip"></mat-icon> {{ 'properties.detail.mappingTab.sendQrcodeByEmail' | translate }}
    </button>

    <!-- «Esporta»: once the switch is live, the four exports come from the new archive, with the rules of its «Esporta» menu (downloadMenu) -->
    <ng-container *ngIf="(loggedUserAdmin || loggedUserMaster) && downloadMenuShown">
    <button class="navigation-button" mat-flat-button [matMenuTriggerFor]="exportMenu" color="primary">
      {{ 'common.export' | translate }}
      <mat-icon class="ml-2" fontSet="fas" fontIcon="fa-caret-down"></mat-icon>
    </button>
    <mat-menu #exportMenu="matMenu">
      <button mat-menu-item *ngIf="loggedUserPermissions.includes('canExportProperties') && downloadMenu.inserted"
        (click)="onExport('insertedDocs2025', propertyId)" color="primary">
        <mat-icon fontSet="fal" fontIcon="fa-file-export"></mat-icon>
        {{ 'properties.list.exportExpiredDocuments' | translate }}
      </button>

      <button mat-menu-item *ngIf="loggedUserPermissions.includes('canExportProperties') && subscriptionType !=='FREE' && subscriptionType !=='FREEBASIC' && downloadMenu.missing"
        (click)="onExport('missingDocs', propertyId)" color="primary">
        <mat-icon fontSet="fal" fontIcon="fa-file-export"></mat-icon>
        {{ 'properties.list.exportMissingDocuments' | translate }}
      </button>

      <button mat-menu-item *ngIf="subscriptionType !=='FREE' && subscriptionType !=='FREEBASIC' && downloadMenu.ras"
        (click)="onExportRAS()" color="primary">
        <mat-icon fontSet="fal" fontIcon="fa-file-export"></mat-icon>
        {{ 'properties.list.exportRas' | translate }}
      </button>

      <button mat-menu-item *ngIf="(loggedUserRoleType === 'admin' || loggedUserRoleType === 'operator') && downloadMenu.contracts"
        (click)="onExportContracts()" color="primary">
        <mat-icon fontSet="fal" fontIcon="fa-file-export"></mat-icon>
        {{ 'properties.list.exportContracts' | translate }}
      </button>
    </mat-menu>
    </ng-container>
  </div>
</div>

<div class="alert alert-danger text-center my-4" *ngIf="property && !property.active">
  {{ 'properties.detail.suspended_property_alert' | translate }}
</div>

<div #card style="position: relative;">
  <mat-card class="custom-card mt-4 mapping-card"
    [ngClass]="{'open-mapping-card': mappaturaOpen || (!mappaturaOpen && !rimappatura && !loggedUserShared && !loggedUserTemporary), 'closed-mapping-card': !mappaturaOpen && rimappatura, 'none-mapping-card': (loggedUserShared || loggedUserTemporary)}">
    <div class="row">
      <div class="col-4">
        <mat-card-title>{{ 'properties.detail.mappingTab.title' | translate }} {{ property?.name }}</mat-card-title>
        <mat-card-subtitle>{{ 'properties.detail.mappingTab.subtitle' | translate }}</mat-card-subtitle>
      </div>
      <div class="col-8 text-right">
        
        <ng-container *ngIf="mappingQrcodeData">
          <qrcode class="d-none" id="mappingQrcodeDataImage" [qrdata]="mappingQrcodeData" [width]="150" [errorCorrectionLevel]="'H'"
            [elementType]="url"></qrcode>
        </ng-container>

        <button mat-raised-button color="primary" (click)="onViewDocumentNotes()"
          *ngIf="!mappaturaOpen && rimappatura && notesExist && loggedUserAdmin" class="mr-2">
          <mat-icon fontSet="fas" fontIcon="fa-sticky-note" color="mr-1"></mat-icon>
          {{ 'properties.structures.showNotes' | translate }}
        </button>

        <ng-container *ngIf="loggedUserAdmin || loggedUserMaster">
          <button class="navigation-button" mat-flat-button [matMenuTriggerFor]="masterMenu" color="primary">
            {{ 'properties.detail.mappingTab.masterMenu.title' | translate }}
            <mat-icon class="ml-2" fontSet="fas" fontIcon="fa-caret-down"></mat-icon>
          </button>
          <mat-menu #masterMenu="matMenu">
            <button mat-menu-item color="primary" (click)="onViewDocumentNotes()"
              *ngIf="!mappaturaOpen && rimappatura && notesExist">
              <mat-icon fontSet="fas" fontIcon="fa-sticky-note"></mat-icon>
              {{ 'properties.detail.mappingTab.masterMenu.showNotes' | translate }}
            </button>

            <button mat-menu-item color="primary" (click)="onViewMapping()">
              <mat-icon fontSet="fal" fontIcon="fa-qrcode"></mat-icon> 
              {{ 'properties.detail.mappingTab.masterMenu.viewMapping' | translate }}
            </button>

            <button mat-menu-item color="primary" (click)="onPrintQRcode()">
              <mat-icon fontSet="fal" fontIcon="fa-qrcode"></mat-icon> 
              {{ 'properties.detail.mappingTab.masterMenu.printQrcode' | translate }}
            </button>
            
            <button mat-menu-item color="accent" (click)="onSendQrcodeByEmail()">
              <mat-icon fontSet="fal" fontIcon="fa-paperclip"></mat-icon> 
              {{ 'properties.detail.mappingTab.masterMenu.sendQrcodeByEmail' | translate }}
            </button>
          </mat-menu>
        </ng-container>

        <button mat-raised-button color="primary" (click)="onToggleStructure('open')"
          *ngIf="!mappaturaOpen && rimappatura">
          <mat-icon fontSet="fal" fontIcon="fa-plus-circle" class="fs-10 mr-1"></mat-icon>
          Apri mappatura
        </button>
        <button mat-raised-button color="warn" (click)="onToggleStructure('close')"
          *ngIf="mappaturaOpen && rimappatura">
          <mat-icon fontSet="fal" fontIcon="fa-times-circle" class="fs-10 mr-1"></mat-icon>
          Chiudi mappatura
        </button>
      </div>
    </div>

    <mat-card-content class="mt-0" [ngClass]="{ 'spinner-area-loading': cardIsLoading }">
      <app-card-spinner [visible]="cardIsLoading" type="zero"></app-card-spinner>

      <div class="row">
        <button class="side-menu-toggle-show" mat-stroked-button color="primary" (click)="showSideMenu = false"
          matTooltip="Nascondi menù laterale" matTooltipPosition="right" *ngIf="showSideMenu">
          Nascondi menù
          <mat-icon fontSet="fas" fontIcon="fa-caret-left">
          </mat-icon>
        </button>
        <button class="side-menu-toggle-show" mat-stroked-button color="primary" (click)="showSideMenu = true"
          matTooltip="Mostra menù laterale" matTooltipPosition="right" *ngIf="!showSideMenu">
          Mostra menù
          <mat-icon fontSet="fas" fontIcon="fa-caret-right">
          </mat-icon>
        </button>
      </div>
      <div class="row" *ngIf="!cardIsLoading">
        <div class="side-menu col-12 col-md-5 col-lg-4" [ngClass]="{ 'd-none': !showSideMenu }">
          <ng-container *ngIf="mappingIndex && mappingIndex.length">
            <mat-accordion class="mapping-index">
              <ng-container *ngFor="let item of mappingIndex; let i = index;">

                <div class="custom-expansion-panel" *ngIf="checkVisibility(item)"
                  [ngClass]="{'openFirstLevel': item.expanded === true}">
                  <!-- *ngIf="mappaturaOpen || (!mappaturaOpen && item.content && item.content.length)" -->
                  <!-- Icon and title accordion -->
                  <a href="javascript:;" class="header-link-wrapper" (click)="onPanelClicked(item, i)">
                    <div class="custom-expansion-panel-header">
                      <div class="custom-expansion-panel-toggle" [ngClass]="{'openFirstLevel': item.expanded === true}">
                      </div>
                      <div class="custom-expansion-panel-header-content">
                        <div class="custom-expansion-panel-header-icon-wrapper" *ngIf="item.icon === ''">
                          <mat-icon fontSet="fal" fontIcon="fa-folder" class="mr-3 fa-fw"
                            [ngClass]="{'d-none': item.expanded === true}"></mat-icon>
                          <mat-icon fontSet="fal" fontIcon="fa-folder-open" class="mr-3 fa-fw"
                            [ngClass]="{'d-none': item.expanded === false}"></mat-icon>
                        </div>
                        <div class="custom-expansion-panel-header-icon-wrapper" *ngIf="item.icon !== ''">
                          <div *ngIf="item.title !== 'properties.structures.amianto'">
                            <mat-icon fontSet="fal" fontIcon="{{ item.icon }}" class="mr-3 fa-fw"></mat-icon>
                          </div>
                          <div *ngIf="item.title === 'properties.structures.amianto'">
                            <svg xmlns="http://www.w3.org/2000/svg" width="54px" height="54px">
                              <text font-weight="50" fill="#ec9451" x="19" y="34" font-size="37">a</text>
                            </svg>
                          </div>
                        </div>
                        <strong>
                          <span *ngIf="lang === 'it' && item.translation">{{ item.translation.it }}</span>
                          <span *ngIf="lang === 'en' && item.translation">{{ item.translation.en }}</span>
                        </strong>
                      </div>
                    </div>
                  </a>

                  <div class="custom-expansion-panel-content">
                    <div *ngIf="item.content.length">
                      <div *ngFor="let subItem of item.content">

                        <ng-container *ngIf="subItem.key === 'anagrafica'">
                          <div class="element no-children-element" [ngClass]="{'active': subItem.active}">
                            <a (click)="activateSection(subItem.section)">
                              <span *ngIf="lang === 'it' && subItem.translation">{{ subItem.translation.it }}</span>
                              <span *ngIf="lang === 'en' && subItem.translation">{{ subItem.translation.en }}</span>
                            </a>
                          </div>
                        </ng-container>

                        <ng-container *ngIf="!subItem.hidden && subItem.type === 'link'
                          && subItem.key !== 'anagrafica'
                          && (mappaturaOpen || (!mappaturaOpen && getChildren(subItem.key).length))">
                          <!-- || (!mappaturaOpen && subItem.key === 'anagrafica' ))"> -->
                          <div matBadge="{{ getChildren(subItem.key).length }}" matBadgePosition="above after"
                            matBadgeColor="primary">
                          </div>
                          <div class="custom-expansion-panel-child"
                            *ngIf="mappaturaOpen || (!mappaturaOpen && getChildren(subItem.key).length)">
                            <a href="javascript:;" class="header-link-wrapper"
                              (click)="subItem.expanded = !subItem.expanded">
                              <div class="custom-expansion-panel-header-second">
                                <div class="custom-expansion-panel-toggle-child"
                                  [ngClass]="{'openSecondLevel': subItem.expanded === true}"></div>
                                <div class="custom-expansion-panel-header-content-second">
                                  <div class="header-title-wrapper">
                                    <span *ngIf="lang === 'it' && subItem.translation">{{ subItem.translation.it }}</span>
                                    <span *ngIf="lang === 'en' && subItem.translation">{{ subItem.translation.en }}</span>
                                  </div>
                                </div>
                              </div>
                            </a>
                            <ul class="custom-expansion-panel-content-list"
                              [ngClass]="{'openSecondLevel': subItem.expanded === true}">
                              <li *ngFor="let subSubitem of getChildren(subItem.key)"
                                [ngClass]="{'active': (model._id === subSubitem._id && subSubitem.active)}"
                                class="element">
                                <a *ngIf="subSubitem.active" (click)="onFormItemClick(subItem.section, subSubitem)" class="link-no-decoration">
                                  <span *ngIf="subItem.key === 'dipendenti'">{{ subSubitem.nome }}
                                    {{ subSubitem.cognome }} </span>
                                  <span *ngIf="subItem.key === 'impresePulizia'">{{ subSubitem.nomeDitta }}</span>
                                  <!-- <span
                                    *ngIf="subItem.key === 'estintori'">{{ 'properties.structures.estintori' | translate }}</span> -->
                                  <span
                                    *ngIf="subItem.key === 'amianto'">{{ 'properties.structures.amianto' | translate }}</span>
                                  <!-- <span
                                    *ngIf="subItem.key !== 'dipendenti' && subItem.key !== 'impresePulizia' && subItem.key !== 'estintori'">{{ subSubitem.nome }}</span> -->
                                  <span
                                    *ngIf="subItem.key !== 'dipendenti' && subItem.key !== 'impresePulizia' && subItem.key !== 'amianto'">{{ subSubitem.nome }}</span>
                                  <div *ngIf="subItem.key === 'fabbricatoAbitativo' && subSubitem.scale">
                                    <span *ngFor="let scala of subSubitem.scale">{{ scala.nomeScala}}</span>
                                  </div>
                                </a>
                              </li>
                              <li class="new-element-wrapper"
                                [ngClass]="{ 'active': subItem.active && !formActiveSubitemId && activeItem }" *ngIf="mappaturaOpen
                                  && (subItem.key !== 'amianto'
                                  || (subItem.key === 'amianto'
                                  && !getChildren(subItem.key).length))">
                                <a title="{{ subItem.buttonTitle | translate  }}"
                                  (click)="activateSection(subItem.section)" class="new-element">
                                  <mat-icon fontSet="fal" fontIcon="fa-layer-plus" class="fa-fw"></mat-icon>
                                  <span>{{ 'properties.structures.newElem' | translate }}</span>
                                </a>
                              </li>
                            </ul>
                          </div>

                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>

              </ng-container>
            </mat-accordion>
          </ng-container>
        </div> <!-- /.col -->

        <div class="col-12" [ngClass]="{ 'side-form-loading': formIsLoading, 'col-md-7 col-lg-8': showSideMenu }">
          <app-card-spinner [visible]="formIsLoading" type="zero"></app-card-spinner>

          <div class="alert alert-info" *ngIf="!formActiveSection">
            <strong>{{ 'properties.structures.warning' | translate }}</strong> <br>
            <p class="mb-0">
              {{ 'properties.structures.selectElem' | translate }}
            </p>
          </div>

          <div *ngIf="formActiveSection && formActiveSubitemId">
            <div class="row">
              <div class="col-10">
                <h4>
                  <span *ngIf="lang === 'it' && activeItem.translation">{{ activeItem.translation.it }}</span>
                  <span *ngIf="lang === 'en' && activeItem.translation">{{ activeItem.translation.en }}</span>
                   {{ model?.nome ? '- ' + model.nome : '' }}
                </h4>
              </div>
              <div class="col-2 text-right" *ngIf="mappaturaOpen && rimappatura">
                <button mat-raised-button [matMenuTriggerFor]="menu" color="primary">
                  {{ 'common.cta.actions' | translate }}
                  <mat-icon class="ml-2" fontSet="fas" fontIcon="fa-caret-down"></mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item
                    *ngIf="activeItem?.key !== 'anagrafica' && activeSubitem && activeSubitem.active && mappaturaOpen"
                    (click)="onEnableEdit()">
                    <mat-icon fontSet="fas" fontIcon="fa-edit" color="primary"></mat-icon>
                    <span *ngIf="sectionPlant">{{ 'properties.structures.modifyPlant' | translate }}</span>
                    <span *ngIf="!sectionPlant">{{ 'properties.structures.modifyElement' | translate }}</span>
                  </button>

                  <button mat-menu-item
                    *ngIf="sectionPlant && activeItem?.key !== 'anagrafica' && activeSubitem && activeSubitem.active && mappaturaOpen"
                    (click)="onRemakeDialog()">
                    <mat-icon fontSet="fas" fontIcon="fa-redo" color="accent"></mat-icon>
                    {{ 'properties.structures.remakePlant' | translate }}
                  </button>

                  <button mat-menu-item
                    *ngIf="activeItem?.key !== 'anagrafica' && activeSubitem && activeSubitem.active && mappaturaOpen"
                    (click)="onDeleteDialog()">
                    <mat-icon fontSet="fas" fontIcon="fa-trash" color="warn"></mat-icon>
                    <span *ngIf="sectionPlant">{{ 'properties.structures.deletePlant' | translate }}</span>
                    <span *ngIf="!sectionPlant">{{ 'properties.structures.deleteElement' | translate }}</span>
                  </button>

                  <!-- <button mat-menu-item (click)="onNoteDialog()">
                    <mat-icon fontSet="fas" fontIcon="fa-sticky-note" color="primary"></mat-icon>
                    {{ 'properties.structures.showNotes' | translate }}
                  </button> -->

                </mat-menu>
              </div>
            </div>

            <hr>

            <div class="form-wrapper mt-3 py-3" *ngIf="!formIsLoading">
              <!-- <app-card-spinner [visible]="formIsLoading" type="zero"></app-card-spinner> -->
              <form [formGroup]="form">
                <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
              </form>
              <mat-spinner-button (btnClick)="onFormSubmit(model, false)" role="submit" [options]="formBtnOptions"
                class="btn-elevate" *ngIf="enableFormModify">
              </mat-spinner-button>
              <div class="note-content">
                <div class="title">{{ 'properties.structures.notes' | translate}}</div>
                <div *ngFor="let item of existingNotes" class="notes">
                  <div class="row mb-3">
                    <div class="col-10">
                      <div class="row">
                        <div class="col-12 createdBy">{{ item.createdBy.firstName }} {{ item.createdBy.lastName }}</div>
                        <div class="col-12 createdAt">{{ item.createdAt | date:'medium' }}</div>
                        <div class="col-12 description">{{ item.text }}</div>
                      </div>
                    </div>
                    <div class="col-2">
                      <div class="row" *ngIf="loggedUserAdmin || loggedUserMaster">
                        <div class="col-6">
                          <mat-icon fontSet="fal" fontIcon="fa-edit" class="icon-action" matTooltip="{{ 'common.cta.modify' | translate}}"
                            (click)="onEdit(item?.text, item._id)">
                          </mat-icon>
                        </div>
                        <div class="col-6">
                          <mat-icon fontSet="fal" fontIcon="fa-trash" class="icon-action" matTooltip="{{ 'common.cta.remove' | translate}}"
                            (click)="onDelete(item._id)">
                          </mat-icon>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
              </div>
            </div> <!-- /.form-wrapper -->
          </div>

          <div *ngIf="!formActiveSubitemId && activeItem">
            <div class="row">
              <div class="col-12">
                <h4>{{ 'properties.structures.newElem' | translate }} - 
                  <span *ngIf="lang === 'it' && activeItem.translation">{{ activeItem.translation.it }}</span>
                  <span *ngIf="lang === 'en' && activeItem.translation">{{ activeItem.translation.en }}</span>
                </h4>
                <!-- @todo translate. Use: activeItem.title -->
                <!-- <h5>{{ 'path.to.translation' | translate: }}</h5>
                "path.to.translation": "Aggiungi un nuovo {{what}}" -->
              </div> <!-- /.col -->
            </div>
            <hr>
            <div class="form-wrapper mt-3 p-3" *ngIf="!formIsLoading">
              <form [formGroup]="form">
                <formly-form [form]="form" [fields]="activeItem.formConfig" [model]="model" [options]="options">
                </formly-form>
              </form>
              <mat-spinner-button (btnClick)="onFormSubmit(model, true)" role="submit" [options]="formBtnOptions"
                class="btn-elevate">
              </mat-spinner-button>
              <div class="note-content">
                <div class="title">{{ 'properties.structures.notes' | translate}}</div>
                <div *ngFor="let item of existingNotes" class="notes">
                  <div class="row mb-3">
                    <div class="col-10">
                      <div class="row">
                        <div class="col-12 createdBy">{{ item.createdBy.firstName }} {{ item.createdBy.lastName }}</div>
                        <div class="col-12 createdAt">{{ item.createdAt | date:'medium' }}</div>
                        <div class="col-12 description">{{ item.text }}</div>
                      </div>
                    </div>
                    <div class="col-2">
                      <div class="row">
                        <div class="col-6">
                          <mat-icon fontSet="fal" fontIcon="fa-edit" class="icon-action" matTooltip="{{ 'common.cta.modify' | translate}}"
                            (click)="onEdit(item?.text, item._id)">
                          </mat-icon>
                        </div>
                        <div class="col-6">
                          <mat-icon fontSet="fal" fontIcon="fa-trash" class="icon-action" matTooltip="{{ 'common.cta.remove' | translate}}"
                            (click)="onDelete(item._id)">
                          </mat-icon>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
              </div>
            </div> <!-- /.form-wrapper -->
            <app-card-spinner [visible]="formIsLoading" type="zero"></app-card-spinner>
          </div>
        </div> <!-- /.col -->
      </div> <!-- /.row -->

    </mat-card-content>
  </mat-card>

</div>